import React, { useEffect } from "react";
import PublicLayout, { H1, Lead, SectionCta } from "../../components/PublicLayout";
import { SITE } from "../../content/site";
import { routePath } from "../../lib/routes";
import { track, EVENTS } from "../../lib/analytics";

export default function Industries({ lang }) {
  const c = SITE[lang].industries;
  useEffect(() => { window.scrollTo(0, 0); }, [lang]);
  return (
    <PublicLayout pageKey="industries" lang={lang}
      crumbs={[{ name: SITE[lang].breadcrumbs.industries, path: routePath("industries", lang) }]}>
      <div className="mx-auto max-w-[1100px] px-6 py-14 md:px-8 md:py-20" data-testid="industries-page">
        <H1>{c.h1}</H1>
        <Lead>{c.intro}</Lead>
        <div className="mt-16 space-y-14">
          {c.groups.map((g) => (
            <section key={g.name} className="border-t border-black/8 pt-10">
              <h2 className="font-display text-2xl font-normal text-[#050505]">{g.name}</h2>
              <div className="mt-6 grid gap-5 sm:grid-cols-2">
                {g.items.map((it) => (
                  <article key={it.name} data-testid={`industry-${it.name.slice(0, 12)}`} className="rounded-2xl border border-black/8 p-6 transition-shadow hover:shadow-[0_4px_24px_rgba(0,0,0,0.06)]">
                    <h3 className="text-base font-medium text-[#050505]">{it.name}</h3>
                    <p className="mt-2 text-sm font-light leading-relaxed text-[#6b6f6c]">{it.desc}</p>
                  </article>
                ))}
              </div>
            </section>
          ))}
        </div>
        <SectionCta title={c.cta.title} text={c.cta.text} lang={lang}
          onClick={() => track(EVENTS.CTA_CLICK, { cta: "industries_contact" })} />
      </div>
    </PublicLayout>
  );
}
